import { SortableElement } from "react-sortable-hoc";

import colors from "core/resources/theme/colors";
import { FaEllipsisV } from "react-icons/fa";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { SortableDragHandle } from "components/SortableDragHandle";

const SortableElementItem = SortableElement(({ ...props }: any) => {
  return <SortableItem {...props} />;
});

export function SortableItem({
  title,
  subtitle,
  right,
  onClick,
  menus,
}: {
  title?: string;
  subtitle?: string;
  right?: any;
  menus?: any[];
  onClick?: any;
}) {
  return (
    <div style={{ flexDirection: "row", minHeight: 60, display: "flex" }}>
      <div
        style={{
          paddingLeft: 4,
          paddingRight: 4,
          borderTopLeftRadius: 6,
          borderBottomLeftRadius: 6,
          backgroundColor: colors.black100,
          alignItems: "center",
          display: "flex",
        }}
      >
        <SortableDragHandle />
      </div>

      <div
        onClick={onClick}
        style={{
          flex: 1,
          backgroundColor: "#F9F9F9",
          justifyContent: "center",
          marginRight: 32,
          display: "flex",
          flexDirection: "column",
          paddingLeft: 16,
          paddingRight: 16,
          cursor: typeof onClick === "function" ? "pointer" : "default",
        }}
      >
        {title ? (
          <div
            style={{
              fontWeight: subtitle ? "normal" : "bold",
              fontSize: subtitle ? 11 : 16,
              color: subtitle ? colors.black600 : colors.black700,
            }}
          >
            {title}
          </div>
        ) : null}
        {subtitle ? <div style={{ fontSize: "1.2em" }}>{subtitle}</div> : null}
      </div>

      {right ? (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          {right}
        </div>
      ) : null}

      {menus?.length ? (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Menu>
            <MenuButton as={Button} variant="link">
              <FaEllipsisV style={{ color: colors.black700, fontSize: 16 }} />
            </MenuButton>
            <MenuList>
              {menus.map((menu) => (
                <MenuItem onClick={() => menu.onClick(menu)}>
                  <span style={{ color: "white" }}>{menu.title}</span>
                </MenuItem>
              ))}
            </MenuList>
          </Menu>
        </div>
      ) : null}
    </div>
  );
}

export default SortableElementItem;
